import * as React from 'react';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
// import PrimaryLayout from 'src/components/layouts/PrimaryLayout';
// import PrimaryComponent from 'src/components/layouts/PrimaryLayout';
import ErrorPage from 'src/components/views/ErrorPage';
import EnvConfig from 'src/constants/EnvConfig';
import LoginComponent from 'src/containers/Login';
import ResetPassword from 'src/containers/ResetPassword';
import PrimaryRoute from './PrimaryRoute';
import { RouterConfig } from './urlConfig';
import PrimaryLayout from 'src/containers/PrimaryLayout';

const RoutersConfig = () => {
  return (
    <Router basename={EnvConfig.server.basename}>
      <Switch>
        <Route path={RouterConfig.Urls.login} exact={true} component={LoginComponent} />
        <Route path={RouterConfig.Urls.reset} component={ResetPassword} />
        <PrimaryRoute path={RouterConfig.Urls.app} component={PrimaryLayout} />
        <Route path={RouterConfig.Urls.notFound} component={ErrorPage} />
        <Redirect to={RouterConfig.Urls.login} />
      </Switch>
    </Router>
  );
};

export default RoutersConfig;



// WEBPACK FOOTER //
// ./src/routers/index.tsx